module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info display_column"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-44px",
      "margin-left": "150px"
    }
  }, [_c('Icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.btn),
      expression: "btn"
    }],
    attrs: {
      "type": "ios-arrow-up",
      "color": "#FFF",
      "size": "30",
      "title": "收拢"
    },
    on: {
      "click": function($event) {
        return _vm.click_openshow()
      }
    }
  }), _vm._v(" "), _c('Icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.btn),
      expression: "!btn"
    }],
    attrs: {
      "type": "ios-arrow-down",
      "color": "#FFF",
      "size": "30",
      "title": "展示"
    },
    on: {
      "click": function($event) {
        return _vm.click_closeup()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info_model display_wrap_as",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('Row', {
    staticClass: "info_model_row"
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "display_row_jc_ac",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', [_vm._v("项目名称")])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_c('div', {
    staticClass: "display_row_jc_ac",
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "line-height": "24px"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.dataList.prjname))])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "display_row_jc_ac",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', [_vm._v("申报书")])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "display_row_jc_ac",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshow),
      expression: "isshow"
    }]
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.info_download
    }
  }, [_vm._v("项目申报书电子版")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isshow),
      expression: "!isshow"
    }]
  }, [_c('span', [_vm._v("项目申报书电子版")])])])])], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row"
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "display_row_jc_ac",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', [_vm._v("所属单位")])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_c('div', {
    staticClass: "display_row_jc_ac",
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "line-height": "24px"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.dataList.DWMC))])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "display_row_jc_ac",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', [_vm._v("项目类别")])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "display_row_jc_ac",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.dataList.prjtype))])])])], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row"
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("合作单位")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_vm._v(_vm._s(_vm.dataList.hzdw))]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  })], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row",
    staticStyle: {
      "height": "120px"
    }
  }, [_c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "120px",
      "line-height": "120px"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("项目负责人")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("学历")]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder",
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("联系电话")])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v(_vm._s(_vm.dataList.fzrname))]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v(_vm._s(_vm.dataList.fzreducation))]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder",
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.dataList.fzrphone))])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("出生年月")]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("职称")]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder",
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("邮箱")])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v(_vm._s(_vm.dataList.fzrbirth))]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v(_vm._s(_vm.dataList.fzrjobtitle))]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder",
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.dataList.fzremail))])])], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row",
    staticStyle: {
      "height": "80px"
    }
  }, [_c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "80px",
      "line-height": "80px"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("项目组" + _vm._s(_vm.dataList.teamnunm) + "人")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "4"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("高级")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dataList.high_level) + "人")])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("中级")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dataList.middle_level) + "人")])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("初级")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dataList.junior) + "人")])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("其他")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dataList.othernum) + "人")])])], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row",
    staticStyle: {
      "height": "150px"
    }
  }, [_c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "150px",
      "line-height": "20px",
      "padding-top": "60px"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("\n        主要研究内容\n        "), _c('br'), _vm._v("和关键技术\n      ")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder display_row_jc_ac",
    staticStyle: {
      "height": "150px",
      "line-height": "24px",
      "padding": "3px",
      "overflow-y": "auto",
      "display": "flex"
    },
    attrs: {
      "span": "19"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.dataList.note))])])], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row"
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_vm._v(_vm._s(_vm.dataList.startdate))]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("结束时间")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v(_vm._s(_vm.dataList.enddate))])], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row",
    staticStyle: {
      "border-bottom": "1px solid #a9a5a5f0"
    }
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("总经费")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_vm._v(_vm._s(_vm.dataList.allfunds))]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("申请园林局拨款")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v(_vm._s(_vm.dataList.yljfunds))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7855e318"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/theme/right/detailed_information/detailed_information.vue
// module id = 1078
// module chunks = 1